import styled from 'styled-components';
export const BreadcrumbsBase = styled.nav.attrs({
    className: 'breadcrumbs',
}) `
  display: inline-flex;
  align-items: center;

  & > button {
    margin: 0 16px;

    cursor: pointer;

    &:focus {
      outline: var(--outline);
      outline-offset: 4px;
    }

    &:focus:not(:focus-visible) {
      outline: none;
      outline-offset: none;
    }
  }

  &:focus:not(:focus-visible) {
    outline: 0;
  }

  &:focus-visible {
    color: var(--color-primary-variant);
    outline: var(--outline);
    outline-offset: 4px;
    & > i {
      color: var(--color-primary-variant);
    }
  }

  &:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > a,
  & > button {
    display: flex;
    align-items: center;
    position: relative;
    line-height: 24px;

    padding: 16px 0;

    border: none;
    box-sizing: border-box;
    background: transparent;

    text-decoration: none;
    color: var(--color-on-background);

    > span {
      text-decoration: underline;
    }
  }

  & > a:not(:hover, :focus, :focus-visible, :active) {
    color: var(--color-inactive);
  }

  & > a + a {
    margin-left: 16px;
  }

  & i {
    color: var(--color-primary);
    margin-left: 16px;
  }
`;
